import React, { useState, useEffect } from 'react';
import { bookCall } from '../../../../api/api';

const BookCallForm: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [skipped, setSkipped] = useState(false);

  useEffect(() => {
    const firstName = localStorage.getItem('userFirstName') || '';
    const lastName = localStorage.getItem('userLastName') || '';
    const email = localStorage.getItem('userEmail') || '';

    if (firstName || lastName || email) {
      setForm({
        name: `${firstName} ${lastName}`.trim(),
        email,
      });
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await bookCall(form);
      if (response.success) {
        setSubmitted(true);
      } else {
        throw new Error('Failed to send.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-xl bg-white rounded-2xl shadow-xl border border-gray-100 p-8 text-center">
      {submitted || skipped ? (
        <div className="py-8 flex flex-col items-center justify-center">
          <h3 className="text-2xl font-bold text-black text-center mb-2">
            Thank you for your interest!
            <br />
            We will get back to you soon.
          </h3>
        </div>
      ) : (
        <>
          <h2 className="text-3xl font-bold text-gray-800 mb-3">
            Are you happy with the call, and want to try it for your business?
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-left font-medium text-gray-800 mb-1">Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-black transition-colors text-gray-900 font-medium"
                placeholder="Enter your name"
              />
            </div>
            <div>
              <label className="block text-left font-medium text-gray-800 mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-black transition-colors text-gray-900 font-medium"
                placeholder="Enter your email"
              />
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 px-6 rounded-xl text-white font-semibold bg-black hover:bg-gray-900 transition-all duration-200 focus:ring-4 focus:ring-gray-200"
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </form>
          <button
            type="button"
            onClick={() => setSkipped(true)}
            className="w-full mt-4 py-4 px-6 rounded-xl text-black font-semibold bg-gray-200 hover:bg-gray-300 transition-all duration-200 focus:ring-4 focus:ring-gray-200"
          >
            Skip
          </button>
          <p className="text-gray-500 text-sm mt-2">
            Want to discuss partnership or have questions? Fill the form and we will reach out!
          </p>
        </>
      )}
    </div>
  );
};

export default BookCallForm;
